import { NewsController as News } from "./controller";

export default News;
